"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _initializeLaunchDarkly = require("@studio/feature.flags/initializeLaunchDarkly");
var useLaunchDarkly = function useLaunchDarkly() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    user = _ref.user,
    team = _ref.team,
    event = _ref.event,
    broadcast = _ref.broadcast;
  var ldKey = arguments.length > 1 ? arguments[1] : undefined;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLDInitializedOrTimedOut = _useState2[0],
    setLDIsInitializedOrTimedOut = _useState2[1];
  var userId = user === null || user === void 0 ? void 0 : user._id;
  var teamId = team === null || team === void 0 ? void 0 : team.id;
  var broadcastId = broadcast === null || broadcast === void 0 ? void 0 : broadcast.id;
  var eventId = event === null || event === void 0 ? void 0 : event.id;
  (0, _react.useEffect)(function () {
    var timeoutId;
    if (userId && ldKey && !isLDInitializedOrTimedOut) {
      console.log('Initializing LaunchDarkly');
      (0, _initializeLaunchDarkly.initializeLaunchDarkly)({
        user: user,
        team: team,
        event: event,
        broadcast: broadcast
      }, ldKey).then(function () {
        clearTimeout(timeoutId);
        setLDIsInitializedOrTimedOut(true);
      });
      timeoutId = setTimeout(function () {
        console.warn('LaunchDarkly initialization timed out after 10 seconds.');
        setLDIsInitializedOrTimedOut(true);
      }, 10000);
    }
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [userId, teamId, eventId, broadcastId, ldKey]);
  return isLDInitializedOrTimedOut;
};
var _default = exports["default"] = useLaunchDarkly;